module.exports = __webpack_public_path__ + "img/friends2.aef0c99.svg";